
var HerefordshireMap = require("../controls/herefordshire-map/map");
var RegionLink = require("../controls/herefordshire-map/regionLink");

var HerefordshireMapService = function() {
    var self = this;

    var $currentContext = $();
    var classMap = {
        map: ".js-herefordshire-map",
        region: ".js-herefordshire-region"
    };

    var moduleOptions = {
        animate: false,
        mapPath: ""
    };

    var _regionModels = [];

    var map = null;
    var links = [];
    var $mapContext;

    var initContext = () => {
        var $mapContext = $(classMap.map, $currentContext);
        map = new HerefordshireMap();
        map.init($mapContext, moduleOptions, _regionModels);

        var $linksContext = $(classMap.region, $currentContext);
        links = $.map($linksContext, (el) => new RegionLink($(el)));
    };

    this.init = function($context, options, regionModels) {
        $.extend(moduleOptions, options);
        $currentContext = $context || $currentContext;

        _regionModels = regionModels;

        initContext();
    };

    Object.seal(self);

    return this;
};

module.exports = HerefordshireMapService;